import React, {useEffect, useState, useMemo, useRef} from 'react'
import SettlementDetailPage from './SettlementDetailPage'
import PatientDetailPage from '../../layout-inpatient/PatientDetailPage'
import DocumentPage from '../../layout-inpatient/DocumentPage'
import CalendarPage from '../../layout-inpatient/tab-components/Calendar'
import {FaChevronLeft, FaChevronRight, FaComment, FaFile} from 'react-icons/fa'
import '../../layout-inpatient/style.css'
import axios from 'axios'
import {useLocation} from 'react-router-dom'
import ChatModal from '../../layout-inpatient/tab-components/ChatModal'
import DocumentModal from '../../layout-inpatient/tab-components/DocumentModal'
import {toast} from 'react-toastify'
import {useAuth} from '../../../modules/auth'
import {useNavigate} from 'react-router-dom'
import DailyMonitoringDetail from '../../layout-inpatient/tab-components/DailyMonitoringDetail'
import SharedLayout from '../../layout-inpatient/tab-components/SharedLayout'
import CalendarView from '../../layout-inpatient/CalendarView'
import {createPusherClient} from '../../../../_metronic/helpers/pusherClient'
import {CreateAppModal} from '../../../../_metronic/partials/modals/request-fgl-stepper/CreateAppModal'
import {saveAs} from 'file-saver'
import {debounce} from 'lodash'
import {setGlobalAttention} from '../../../../_metronic/layout/components/header/Header'
import {useClaimAttention} from '../../../../hooks/useClaimAttention'
import {usePageData} from '../../../../_metronic/layout/core'

interface DocumentStatus {
  status: string
  id: number
  name: string
  isArchive: boolean
}

interface DiagnosisData {
  mainDiagnosis?: string
  supportingDiagnosis?: string
  supportingDiagnosis3?: string
  supportingDiagnosis4?: string
  icd1?: string
  icd2?: string
  icd3?: string
  icd4?: string
  doctor?: string
  polyName?: string
  remark?: string
  deposit?: string
  rencanaTindakan?: string
  losEstimation?: string
  originalIcdCodes?: {
    icd1?: string
    icd2?: string
    icd3?: string
    icd4?: string
  }
}

const SettlementDetailPageWrapper: React.FC = () => {
  const user = useAuth()
  const {auth} = useAuth()
  const location = useLocation()
  const navigate = useNavigate()
  const claimDetails = location.state as {claimDetails: any}
  const [activeKey, setActiveKey] = useState<string>('diagnosis')
  const [validationData, setValidationData] = useState<any>(null)
  const [isDataValid, setIsDataValid] = useState<boolean>(false)
  const [isEditingDiagnosis, setIsEditingDiagnosis] = useState<boolean>(false)
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false)
  const [chatMessage, setChatMessage] = useState<string>('')
  const [currentView, setCurrentView] = useState<
    'inpatient' | 'calendar' | 'dailyMonitoringDetail' | 'discharged' | 'settlement'
  >('inpatient')
  const status = claimDetails.claimDetails.claim.status
  const [showFGLModal, setShowFGLModal] = useState<boolean>(false)
  const [formattedDate, setFormattedDate] = useState<string>(new Date().toISOString().split('T')[0])
  const [incomingsinglefile, setIncomingsinglefile] = useState<any>(null)
  const [documentsUploaded, setDocumentsUploaded] = useState<boolean>(false)
  const [diagnosisFieldsFilled, setDiagnosisFieldsFilled] = useState<boolean>(false)
  const [documentsUploadedNew, setDocumentsUploadedNew] = useState<boolean>(false)
  const [notificationCount, setNotificationCount] = useState(0)
  const [hasNewNotification, setHasNewNotification] = useState(false)
  const [isFromDailyMonitoring, setIsFromDailyMonitoring] = useState<boolean>(false)
  const [documentRealtime, setDocumentRealtime] = useState<any>(null)
  const [view, setView] = useState<string>('inpatient')
  const [loading, setLoading] = useState<boolean>(false)
  const jsonString = claimDetails?.claimDetails?.claim?.detailBenefit
  const parsedJson = jsonString ? JSON.parse(jsonString) : {}
  const jsonString2 = claimDetails?.claimDetails?.claim?.claimData
  const parsedJson2 = jsonString2 ? JSON.parse(jsonString2) : {}

  const [documentsStatus, setDocumentsStatus] = useState<{
    hasInvalid: boolean
    allUploaded: boolean
  }>({
    hasInvalid: false,
    allUploaded: false,
  })

  // Add new state to track document statuses
  const [documentStatuses, setDocumentStatuses] = useState<{
    [key: string]: {status: string; id: number; name: string; isArchive: boolean}
  }>({})

  // Add new state to track last notification
  const [lastNotification, setLastNotification] = useState<{
    label: string
    status: string
    timestamp: number
  } | null>(null)

  // Add this state at the top with other state declarations
  const [lastToastTime, setLastToastTime] = useState<number>(0)

  // Mirror of lastToastTime for the Pusher handler to read. The handler both reads
  // and sets it, so keeping it (and documentStatuses) in the Pusher effect's deps
  // rebuilt the client on every file event. See docs/plan/IDH-1620.
  const lastToastTimeRef = useRef<number>(lastToastTime)
  useEffect(() => {
    lastToastTimeRef.current = lastToastTime
  }, [lastToastTime])

  // Add new state for button
  const [isButtonEnabled, setIsButtonEnabled] = useState<boolean>(false)
  const [isAttentionEnabled, setIsAttentionEnabled] = useState<boolean>(false)

  // Add state for diagnosis validation
  const [isDiagnosisValid, setIsDiagnosisValid] = useState<boolean>(false)

  // Add state for editing
  const [isEditing, setIsEditing] = useState<boolean>(false)

  // Add new state for diagnosis data
  const [diagnosisData, setDiagnosisData] = useState<DiagnosisData>({})

  const {addClaimNumber, removeClaimNumber} = usePageData()

  // Add this state if not already present
  const [isChatModalOpen, setIsChatModalOpen] = useState<boolean>(false)

  // Add handler for diagnosis data changes
  const handleDiagnosisDataChange = (newData: Partial<DiagnosisData>) => {
    setDiagnosisData((prevData) => ({
      ...prevData,
      ...newData,
      originalIcdCodes: {
        ...prevData.originalIcdCodes,
        icd1: newData.icd1 || prevData.originalIcdCodes?.icd1,
        icd2: newData.icd2 || prevData.originalIcdCodes?.icd2,
        icd3: newData.icd3 || prevData.originalIcdCodes?.icd3,
        icd4: newData.icd4 || prevData.originalIcdCodes?.icd4,
      },
    }))

    console.log('Updated Diagnosis Data:', {
      ...diagnosisData,
      ...newData,
      originalIcdCodes: {
        ...diagnosisData.originalIcdCodes,
        icd1: newData.icd1 || diagnosisData.originalIcdCodes?.icd1,
        icd2: newData.icd2 || diagnosisData.originalIcdCodes?.icd2,
        icd3: newData.icd3 || diagnosisData.originalIcdCodes?.icd3,
        icd4: newData.icd4 || diagnosisData.originalIcdCodes?.icd4,
      },
    })
  }

  // Create debounced fetch outside of useEffect to maintain reference
  const debouncedFetch = debounce(async () => {
    await checkDocumentStatuses()
  }, 1000) // 1 second delay

  console.log('File Data:', claimDetails.claimDetails)

  useEffect(() => {
    if (status === 'Registered' || status === 'Pre-Registered') {
      setIsEditingDiagnosis(true)
    } else {
      setIsEditingDiagnosis(false)
    }
  }, [status])

  const handleDocumentsStatusChange = (status: boolean) => {
    setDocumentsUploaded(status)
  }

  useEffect(() => {
    const fetchData = async () => {
      const claimNumber = claimDetails.claimDetails.claim.claimNumber
      const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/ListFiles/${claimNumber}`
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        })
        if (response.data.isSuccess) {
          setValidationData(response.data.data)
          validateDocuments(response.data.data)
        } else {
          console.error('Failed to fetch documents:', response.data.message)
        }
      } catch (error) {
        console.error('Error fetching documents:', error)
      }
    }

    fetchData()
  }, [claimDetails])

  useEffect(() => {
    console.log('Current View: ', currentView)
  }, [currentView])

  const validateDocuments = (data: any[]) => {
    // Filter out Prescription documents first
    const relevantDocuments = data.filter((doc) => doc.label !== 'Prescription')

    // Check if any document has INVALID status
    const hasInvalidDocuments = relevantDocuments.some(
      (doc) =>
        doc.document &&
        doc.document.length > 0 &&
        doc.document.some((file) => file.status === 'INVALID' || file.status === 'Request Document')
    )

    // Check if all required documents are present and uploaded
    const requiredLabels = [
      'Lembar Medis Awal',
      'Copy KTP Pasien',
      'Copy Kartu Asuransi Pasien',
      'Surat Pernyataan (SP)',
      'Medical Inquiry',
      'Hasil Penunjang',
    ]

    const hasAllDocuments = requiredLabels.every((label) =>
      relevantDocuments.some(
        (item) => item.label === label && item.document && item.document.length > 0
      )
    )

    console.log('Has Invalid Documents:', hasInvalidDocuments)
    console.log('Has All Documents:', hasAllDocuments)

    // Only set documentsUploaded to true if all documents are present AND none are invalid
    setDocumentsUploaded(hasAllDocuments && !hasInvalidDocuments)
    setIsDataValid(hasAllDocuments && !hasInvalidDocuments)
  }

  const validateDiagnosisFields = (diagnosisData: any) => {
    setIsDiagnosisValid(diagnosisData.isValid)
  }

  const handleEditClick = () => {
    setIsEditingDiagnosis(true)
  }

  const handleDocumentClick = (docLabel: string) => {
    setChatMessage(docLabel)
    setIsChatOpen(true)
  }

  const handleRequestIGL = async (e: React.FormEvent) => {
    e.preventDefault()

    if (status !== 'Pre-Registered' && status !== 'Pending on IGL') {
      return
    }

    // Disable attention message immediately
    setIsAttentionEnabled(false)
    setGlobalAttention(false, claimDetails.claimDetails.claim.claimNumber, status)

    setLoading(true)
    try {
      if (status === 'Pre-Registered') {
        if (parsedJson?.Deposit) {
          await updateClaimStatus()
        } else {
          await saveDiagnosisData()
          await updateClaimStatus()
        }
        navigate('/claims')
      } else if (status === 'Pending on IGL') {
        await updateClaimStatus()
        navigate('/claims')
      }
    } catch (error) {
      console.error('Error in handleRequestIGL:', error)
      handleError(error)
      // Re-enable attention on error
      setIsAttentionEnabled(true)
      setGlobalAttention(true, claimDetails.claimDetails.claim.claimNumber, status)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    console.log('Diagnosis Data Kontol:', diagnosisData)
  }, [diagnosisData])

  // Helper function to save diagnosis data
  const saveDiagnosisData = async () => {
    const existingData = claimDetails.claimDetails.claim.claimData
    const parsedExistingData = existingData ? JSON.parse(existingData) : {}

    const payload = {
      claimNo: claimDetails?.claimDetails?.claim?.claimNumber,
      icdCode1: diagnosisData.originalIcdCodes?.icd1 || parsedJson2?.IcdCode1 || '',
      icdCode2: diagnosisData.originalIcdCodes?.icd2 || parsedJson2?.IcdCode2 || '',
      icdCode3: diagnosisData.originalIcdCodes?.icd3 || parsedJson2?.IcdCode3 || '',
      icdCode4: diagnosisData.originalIcdCodes?.icd4 || parsedJson2?.IcdCode4 || '',
      doctor: diagnosisData.doctor || parsedExistingData?.Doctor || '',
      polyName: diagnosisData.polyName || parsedExistingData?.PolyName || '',
      remark: diagnosisData.remark || parsedExistingData?.Remark || '',
      deposit: diagnosisData.deposit || parsedExistingData?.Deposit || '',
      treatmentPlan: diagnosisData.rencanaTindakan || parsedExistingData?.TreatmentPlan || '',
      los: diagnosisData.losEstimation
        ? parseInt(diagnosisData.losEstimation)
        : parseInt(parsedExistingData?.Los) || '',
      updatedBy: user.currentUser?.email,
      BenefitDetail: {
        id: parsedJson?.Id,
        benefitName: parsedJson?.BenefitName,
        planName: parsedJson?.PlanName,
        benefitCode: parsedJson?.BenefitCode,
        condition: parsedJson?.Condition,
        annualLimit: parsedJson?.AnnualLimit,
        subBenefits:
          parsedJson?.SubBenefits?.map((subBenefit: any) => ({
            id: subBenefit.Id,
            category: 'INPATIENT',
            SubBenefitName: subBenefit.SubBenefitName,
            isCashless: subBenefit.IsCashless,
            isReimburstement: subBenefit.IsReimburstement,
            annualLimit: subBenefit.AnnualLimit,
            type: subBenefit.Type,
            claimValue: subBenefit.ClaimValue,
            details: subBenefit.Details,
            condition: subBenefit?.Condition || [],
          })) || [],
      },
    }

    console.log('Payload:', JSON.stringify(payload, null, 2))

    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/Provider/ProcessClaim/INPATIENT`,
      payload,
      {headers}
    )

    if (!response.data.isSuccess) {
      throw new Error('Failed to save diagnosis data')
    }

    toast.success('Successfully saved as draft!', {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: 'light',
    })

    setIsEditing(false)
  }

  // Helper function to update claim status
  const updateClaimStatus = async () => {
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/UpdateStatus`
    const payload = {
      claimNumber: claimDetails.claimDetails.claim.claimNumber,
      status: 'Request IGL',
      username: user.currentUser?.email,
      source: 'Provider',
    }
    const headers = {
      Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
    }

    const response = await axios.post(apiUrl, payload, {headers})

    if (!response.data.isSuccess) {
      throw new Error('Failed to submit IGL Request')
    }

    // Clear recently uploaded tracking on successful submission
    sessionStorage.removeItem('recentlyUploadedLabels')

    toast.success('IGL Request submitted successfully!', {
      position: 'bottom-right',
      autoClose: 3000,
    })
  }

  // Helper function to handle errors
  const handleError = (error: any) => {
    const errorMessage = error.response?.data?.message || error.message || 'An error occurred'

    toast.error(errorMessage, {
      position: 'bottom-right',
      autoClose: 3000,
    })
  }

  const handleRequestFGL = () => {
    setShowFGLModal(true)
  }

  // Update initial view and active key based on status
  useEffect(() => {
    if (
      status === 'FGL RELEASED' ||
      status === 'Request FGL' ||
      status === 'Final Document Complete' ||
      status === 'FGL Review' ||
      status === 'Pending on FGL'
    ) {
      setCurrentView('settlement')
      setView('settlement')
      setActiveKey('settlement')
    }
  }, [status])

  // Update the visibility conditions for prev/next buttons
  const showPrevButton =
    status === 'FGL RELEASED' ||
    status === 'Request FGL' ||
    status === 'Final Document Complete' ||
    status === 'FGL Review' ||
    status === 'Pending on FGL' ||
    ((status === 'IGL RELEASED' || status === 'Daily Monitoring') && currentView === 'calendar')

  const showNextButton =
    // Show next button on inpatient view for FGL statuses
    ((status === 'FGL RELEASED' ||
      status === 'Request FGL' ||
      status === 'Final Document Complete' ||
      status === 'FGL Review' ||
      status === 'Pending on FGL') &&
      currentView === 'inpatient') ||
    // Show next button for IGL/Daily Monitoring statuses on inpatient
    ((status === 'IGL RELEASED' || status === 'Daily Monitoring') && currentView === 'inpatient') ||
    // Show next button on calendar view for FGL statuses
    ((status === 'FGL RELEASED' ||
      status === 'Request FGL' ||
      status === 'Final Document Complete' ||
      status === 'FGL Review' ||
      status === 'Pending on FGL') &&
      currentView === 'calendar')

  // Update the navigation handler
  const handleViewNavigation = (direction: 'prev' | 'next') => {
    if (
      status === 'FGL RELEASED' ||
      status === 'Request FGL' ||
      status === 'Final Document Complete' ||
      status === 'FGL Review' ||
      status === 'Pending on FGL'
    ) {
      if (currentView === 'discharged') {
        if (direction === 'prev') {
          setCurrentView('calendar')
          setView('calendar')
          setActiveKey('calendar')
        }
      } else if (currentView === 'calendar') {
        if (direction === 'prev') {
          setCurrentView('inpatient')
          setView('inpatient')
          setActiveKey('diagnosis')
        } else if (direction === 'next') {
          setCurrentView('discharged')
          setView('discharged')
          setActiveKey('discharged')
        }
      } else if (currentView === 'inpatient') {
        if (direction === 'next') {
          setCurrentView('calendar')
          setView('calendar')
          setActiveKey('calendar')
        }
      }
    } else if (status === 'IGL RELEASED' || status === 'Daily Monitoring') {
      if (direction === 'next') {
        setCurrentView('calendar')
        setView('calendar')
        setActiveKey('calendar')
      } else if (direction === 'prev') {
        setCurrentView('inpatient')
        setView('inpatient')
        setActiveKey('diagnosis')
      }
    }
  }

  useEffect(() => {
    if (status === 'Request IGL') {
      console.log('View changed to:', view)
      if (view === 'calendar') {
        setActiveKey('calendar')
      } else if (view === 'inpatient') {
        setActiveKey('diagnosis')
      }
    } else if (status === 'Request FGL') {
      if (view === 'discharged') {
        setActiveKey('discharged')
      }
    }
  }, [view, status])

  useEffect(() => {
    console.log('View changed to:', currentView)
  }, [currentView])

  useEffect(() => {
    const pusher = createPusherClient('SettlementDetail')

    const claimNumber = claimDetails.claimDetails.claim.claimNumber

    // Subscribe to list-file-channel
    const listFileChannel = pusher.subscribe(`list-file-channel-${claimNumber}`)

    // Subscribe to file-channel-{claimNumber}
    const fileStatusChannel = pusher.subscribe(`file-channel-${claimNumber}`)

    // Handle list-file updates
    listFileChannel.bind(`get-list-${claimNumber}`, (data: any) => {
      console.log('Received list file data:', data)
      setDocumentRealtime(data)

      if (data.isSuccess) {
        const apiDocuments = data.data.filter((doc: any) => doc.label !== 'Prescription')

        // Update states as before
        setDocumentStatuses((prev) => {
          const newDocumentStatuses = {...prev}
          apiDocuments.forEach((doc: any) => {
            if (doc.document?.[0]) {
              newDocumentStatuses[doc.label] = {
                status: doc.document[0].status,
                id: doc.document[0].id,
                name: doc.document[0].name,
                isArchive: doc.document[0].isArchive,
              }
            }
          })
          return newDocumentStatuses
        })
      }
    })

    // Handle individual file status updates
    fileStatusChannel.bind(`get-${claimNumber}`, (data: any) => {
      if (data && data.message) {
        const {message} = data
        const {Label, Status, Id, DocumentName, isArchive, UpdatedBy} = message

        // Update document statuses
        setDocumentStatuses((prev) => {
          const newStatuses = {
            ...prev,
            [Label]: {
              status: Status,
              id: Id,
              name: DocumentName,
              isArchive: isArchive,
            },
          }

          // Check required documents
          const requiredLabels = [
            'Lembar Medis Awal',
            'Copy KTP Pasien',
            'Copy Kartu Asuransi Pasien',
            'Surat Pernyataan (SP)',
            'Medical Inquiry',
            'Hasil Penunjang',
          ]

          // Check if any document has INVALID status
          const hasInvalidDocuments = Object.values(newStatuses).some(
            (doc: any) => doc.status === 'INVALID' || doc.status === 'Request Document'
          )

          // Check if all required documents are uploaded (regardless of status)
          const allRequiredUploaded = requiredLabels.every(
            (label) => newStatuses[label] !== undefined
          )

          // Update states immediately
          setDocumentsUploaded(allRequiredUploaded)
          setIsDataValid(!hasInvalidDocuments)

          return newStatuses
        })

        // Handle toast notifications with debouncing
        const now = Date.now()
        if (
          Status === 'INVALID' ||
          (Status === 'Request Document' && now - lastToastTimeRef.current > 5000)
        ) {
          // Clear any existing toasts first
          toast.dismiss()

          toast.error(`${Label} has been rejected by ${UpdatedBy}. Please review and resubmit.`, {
            position: 'top-right',
            autoClose: 3000,
          })
          setLastToastTime(now)
        }
      }
    })

    // Debug subscriptions
    console.log('Subscribed to channels:', {
      listChannel: `list-file-channel-${claimNumber}`,
      fileChannel: `file-channel-${claimNumber}`,
      fileEvent: `get-${claimNumber}`,
    })

    return () => {
      listFileChannel.unbind_all()
      fileStatusChannel.unbind_all()
      pusher.unsubscribe(`list-file-channel-${claimNumber}`)
      pusher.unsubscribe(`file-channel-${claimNumber}`)
      pusher.disconnect()
    }
  }, [claimDetails.claimDetails.claim.claimNumber])

  // Add debug logging
  useEffect(() => {
    const checkAndUpdateDocuments = async () => {
      if (documentStatuses && typeof documentStatuses === 'object') {
        // Check if any document has INVALID status
        const hasInvalidStatus = Object.values(documentStatuses).some(
          (doc: DocumentStatus) => doc.status === 'INVALID' || doc.status === 'Request Document'
        )

        console.log('Document Status Check:', {
          currentStatus: documentStatuses,
          hasInvalidStatus,
          documentDetails: Object.entries(documentStatuses).map(([label, doc]) => ({
            label,
            status: doc.status,
          })),
          timestamp: new Date().toISOString(),
        })

        // Only trigger fetch if status is changing to INVALID or IDLE
        const statusChanged = Object.values(documentStatuses).some(
          (doc) =>
            doc.status === 'INVALID' || doc.status === 'IDLE' || doc.status === 'Request Document'
        )

        if (statusChanged) {
          debouncedFetch()
        }
      }
    }

    checkAndUpdateDocuments()
    setIncomingsinglefile(documentStatuses)

    console.log('Current document statuses:', documentStatuses)

    // Cleanup
    return () => {
      debouncedFetch.cancel()
    }
  }, [documentStatuses]) // Remove isDataValid and documentsStatus from dependencies

  useEffect(() => {
    console.log(
      'Component re-rendered. Current notification count:',
      notificationCount,
      'New notification:',
      hasNewNotification
    )
  }, [notificationCount, hasNewNotification])

  // Set default view based on status
  useEffect(() => {
    if (status === 'IGL RELEASED') {
      setCurrentView('inpatient')
      setActiveKey('diagnosis')
    } else if (status === 'Daily Monitoring') {
      setCurrentView('calendar')
      setActiveKey('calendar')
    }
  }, [status])

  const isMonitoringOrFGL = status === 'Daily Monitoring' || status === 'Request FGL'

  const tabStyle = {
    cursor: 'pointer',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
    backgroundColor: 'white',
  }

  const activeTabStyle = {
    backgroundColor: 'rgba(243, 245, 247, 1)',
    color: '#000',
  }

  const handleDocumentsClick = () => {
    setIsChatOpen(true)
  }

  const checkDocumentStatuses = async () => {
    const claimNumber = claimDetails.claimDetails.claim.claimNumber
    const apiUrl = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/ListFiles/${claimNumber}`

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
        },
      })

      if (response.data.isSuccess) {
        const documents = response.data.data

        // Check if all required documents are uploaded
        const requiredLabels = [
          'Lembar Medis Awal',
          'Copy KTP Pasien',
          'Copy Kartu Asuransi Pasien',
          'Surat Pernyataan (SP)',
          'Medical Inquiry',
          'Hasil Penunjang',
        ]

        const allUploaded = requiredLabels.every((label) => {
          const doc = documents.find((d: any) => d.label === label)
          return doc && doc.document && doc.document.length > 0
        })

        // Check if any document has INVALID status
        const hasInvalid = documents.some((doc: any) => {
          // Skip Prescription documents
          if (doc.label === 'Prescription') return false

          return (
            doc.document &&
            doc.document.length > 0 &&
            doc.document.some(
              (file: any) =>
                file.status === 'INVALID' ||
                file.status === 'Request Document' ||
                file.status === 'REQUEST'
            )
          )
        })

        setDocumentsStatus({
          hasInvalid,
          allUploaded,
        })

        console.log('Document Status Check:', {
          allUploaded,
          hasInvalid,
          documents: documents.map((d: any) => ({
            label: d.label,
            status: d.document?.[0]?.status,
          })),
        })
      }
    } catch (error) {
      console.error('Error checking document statuses:', error)
    }
  }

  useEffect(() => {
    if (['Registered', 'Pre-Registered', 'Pending on IGL'].includes(status)) {
      checkDocumentStatuses()
    }
  }, [status])

  const canRequestIGL = useMemo(() => {
    // Check if there are any documents
    const hasDocuments = documentRealtime?.message?.Data?.length > 6

    const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL'].includes(status)
    const validDocuments = hasDocuments && documentsUploaded && !documentsStatus.hasInvalid
    // console.log("validDocuments : ", validDocuments);

    console.log('Request IGL Button State:', {
      hasDocuments,
      validStatus,
      documentsUploaded,
      hasInvalidDocuments: documentsStatus.hasInvalid,
      finalState: validStatus && validDocuments,
    })

    // Button state only depends on documents and status
    return isDataValid && validStatus && validDocuments
  }, [documentRealtime?.message?.Data, status, documentsUploaded, documentsStatus.hasInvalid])

  const handleDownloadIGL = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_CLAIM_URL}/api/Attachment/DownloadIGL/${claimDetails.claimDetails.claim.claimNumber}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        }
      )

      if (!response.ok) {
        throw new Error('Failed to fetch IGL document')
      }

      const data = await response.json()

      if (data && data.url) {
        // Open URL in new tab to trigger download
        window.open(data.url, '_blank')

        toast.success('IGL download started!', {
          position: 'top-right',
          autoClose: 3000,
        })
      } else {
        throw new Error('Invalid response format')
      }
    } catch (error) {
      console.error('Error downloading IGL:', error)
      toast.error('Failed to download IGL', {
        position: 'top-right',
        autoClose: 3000,
      })
    }
  }

  const handleDownloadFGL = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_CLAIM_URL}/api/Attachment/DownloadFGL/${claimDetails.claimDetails.claim.claimNumber}`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
          },
        }
      )

      if (!response.ok) {
        throw new Error('Failed to fetch FGL document')
      }

      const data = await response.json()

      if (data && data.url) {
        // Open URL in new tab to trigger download
        window.open(data.url, '_blank')

        toast.success('FGL download started!', {
          position: 'top-right',
          autoClose: 3000,
        })
      } else {
        throw new Error('Invalid response format')
      }
    } catch (error) {
      console.error('Error downloading FGL:', error)
      toast.error('Failed to download FGL', {
        position: 'top-right',
        autoClose: 3000,
      })
    }
  }

  console.log('Document Realtime:', JSON.stringify(documentRealtime, null, 2))

  useEffect(() => {
    if (documentRealtime?.message?.IsSuccess) {
      const apiDocuments = documentRealtime.message.Data.filter(
        (doc: any) => doc.Label !== 'Prescription'
      )

      const documentStatuses = apiDocuments.map((doc) => ({
        label: doc.Label,
        status: doc.Document?.[0]?.Status || 'NO_DOCUMENT',
        hasDocument: Boolean(doc.Document && doc.Document.length > 0),
      }))

      const hasInvalidDocuments = documentStatuses.some(
        (doc) => doc.status === 'INVALID' || doc.status === 'Request Document'
      )

      const allDocumentsUploaded = documentStatuses.every((doc) => doc.hasDocument)

      setDocumentsUploaded(allDocumentsUploaded)
      setIsDataValid(!hasInvalidDocuments)

      setDocumentsStatus({
        hasInvalid: hasInvalidDocuments,
        allUploaded: allDocumentsUploaded,
      })

      // Calculate button state with both document and diagnosis validation
      const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL'].includes(status)
      const shouldEnableButton =
        validStatus && allDocumentsUploaded && !hasInvalidDocuments && isDiagnosisValid

      setIsButtonEnabled(shouldEnableButton)
      if (status === 'Pending on IGL') {
        setIsAttentionEnabled(shouldEnableButton)
        setGlobalAttention(shouldEnableButton, claimDetails.claimDetails.claim.claimNumber, status)
      } else {
        setIsAttentionEnabled(shouldEnableButton)
        setGlobalAttention(shouldEnableButton, claimDetails.claimDetails.claim.claimNumber, status)
      }

      console.log('Button State Calculation:', {
        validStatus,
        allDocumentsUploaded,
        hasInvalidDocuments,
        isDiagnosisValid,
        shouldEnableButton,
        currentTime: new Date().toISOString(),
      })
    }
  }, [documentRealtime, status, isDiagnosisValid])

  // Add another useEffect to handle diagnosis-only validation
  useEffect(() => {
    const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL'].includes(status)
    const shouldEnableButton =
      validStatus && documentsStatus.allUploaded && !documentsStatus.hasInvalid && isDiagnosisValid

    setIsButtonEnabled(shouldEnableButton)
    if (status === 'Pending on IGL') {
      setIsAttentionEnabled(shouldEnableButton)
      setGlobalAttention(shouldEnableButton, claimDetails.claimDetails.claim.claimNumber, status)
    } else {
      setIsAttentionEnabled(shouldEnableButton)
      setGlobalAttention(shouldEnableButton, claimDetails.claimDetails.claim.claimNumber, status)
    }
  }, [isDiagnosisValid, status, documentsStatus])

  // Add this state at the top with other states
  const [shouldEnableButton, setShouldEnableButton] = useState<boolean>(false)

  // Add this useEffect to track button state
  useEffect(() => {
    const validStatus = ['Registered', 'Pre-Registered', 'Pending on IGL'].includes(status)
    const hasDocuments = documentRealtime?.message?.Data?.length > 1
    const validDocuments = hasDocuments && documentsUploaded && !documentsStatus.hasInvalid
    const shouldEnable = validStatus && validDocuments && isDiagnosisValid

    console.log('Button State Calculation:', {
      validStatus,
      hasDocuments,
      documentsUploaded,
      hasInvalidDocuments: documentsStatus.hasInvalid,
      isDiagnosisValid,
      shouldEnable,
      currentTime: new Date().toISOString(),
    })

    setShouldEnableButton(shouldEnable)
  }, [
    status,
    documentRealtime?.message?.Data,
    documentsUploaded,
    documentsStatus.hasInvalid,
    isDiagnosisValid,
  ])

  // Add handlers for save and cancel
  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault()
    console.log('Diagnosis Data Wrapper : ', diagnosisData)
    setLoading(true)
    try {
      const existingData = claimDetails?.claimDetails?.claim?.claimData
      const parsedExistingData = existingData ? JSON.parse(existingData) : {}

      const payload = {
        claimNo: claimDetails?.claimDetails?.claim?.claimNumber,
        icdCode1: diagnosisData?.originalIcdCodes?.icd1 || parsedExistingData?.IcdCode1 || '',
        icdCode2: diagnosisData?.originalIcdCodes?.icd2 || parsedExistingData?.IcdCode2 || '',
        icdCode3: diagnosisData?.originalIcdCodes?.icd3 || parsedExistingData?.IcdCode3 || '',
        icdCode4: diagnosisData.originalIcdCodes?.icd4 || parsedExistingData.icdCode4 || '',
        doctor: diagnosisData.doctor || parsedExistingData.doctor || '',
        polyName: diagnosisData.polyName || parsedExistingData.polyName || '',
        remark: diagnosisData.remark || parsedExistingData.remark || '',
        deposit: diagnosisData.deposit || parsedExistingData.deposit || '',
        treatmentPlan: diagnosisData.rencanaTindakan || parsedExistingData.rencanaTindakan || '',
        los: diagnosisData.losEstimation
          ? parseInt(diagnosisData.losEstimation)
          : parseInt(parsedExistingData.los) || 0,
        updatedBy: user.currentUser?.email,
        BenefitDetail: {
          id: parsedJson?.Id,
          benefitName: parsedJson?.BenefitName,
          planName: parsedJson?.PlanName,
          benefitCode: parsedJson?.BenefitCode,
          condition: parsedJson?.Condition,
          annualLimit: parsedJson?.AnnualLimit,
          subBenefits:
            parsedJson?.SubBenefits?.map((subBenefit: any) => ({
              id: subBenefit.Id,
              category: 'INPATIENT',
              SubBenefitName: subBenefit.SubBenefitName,
              isCashless: subBenefit.IsCashless,
              isReimburstement: subBenefit.IsReimburstement,
              annualLimit: subBenefit.AnnualLimit,
              type: subBenefit.Type,
              claimValue: subBenefit.ClaimValue,
              details: subBenefit.Details,
              condition: subBenefit?.Condition || [],
            })) || [],
        },
      }

      console.log('Payload:', JSON.stringify(payload, null, 2))

      const headers = {
        Authorization: `Bearer ${auth?.token}` || `Bearer ${user.currentUser?.token}`,
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/Provider/ProcessClaim/INPATIENT`,
        payload,
        {headers}
      )

      if (response.data.isSuccess) {
        toast.success('Successfully saved as draft!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: 'light',
          onOpen: () => {
            console.log('Toast opened')
          },
        })
        setIsEditing(false)
      } else {
        toast.error('Failed to save diagnosis data')
      }
    } catch (error: any) {
      console.error('Error saving diagnosis data:', error)
      toast.error(error.response?.data?.message || 'Error saving diagnosis data')
    }
  }

  const handleCancel = () => {
    // Your cancel logic here
    setIsEditing(false)
  }

  // Add handler for edit
  const handleEdit = () => {
    setIsEditing(true)
  }

  useEffect(() => {
    if (claimDetails?.claimDetails?.claim?.claimNumber) {
      const claimNumber = claimDetails.claimDetails.claim.claimNumber
      addClaimNumber(claimNumber)

      return () => {
        removeClaimNumber(claimNumber)
      }
    }
  }, [claimDetails])

  return (
    <>
      <div className='card card-custom gutter-b' style={{marginTop: '-50px'}}>
        <div className='frame-header'>
          <div className='frame-headertop'>
            <div className='frame-menu2'>
              <span className='frame-text36'>{claimDetails.claimDetails.claim.cardNumber}</span>
              <div className='frame-row25'>
                <div className='frame-label20'>
                  <span className='frame-text37'>Rawat Inap</span>
                </div>
              </div>
            </div>
            <div className='frame-row26'>
              <div
                className={
                  status.toLowerCase() === 'pending data'
                    ? 'frame-statuslabel'
                    : status.toLowerCase() == 'daily monitoring'
                    ? 'frame-statuslabel-1'
                    : 'frame-statuslabel-2'
                }
              >
                <span
                  className={
                    status.toLowerCase() === 'pending data'
                      ? 'frame-text38'
                      : status.toLowerCase() == 'daily monitoring'
                      ? 'frame-text42'
                      : 'frame-text45'
                  }
                >
                  {status}
                </span>
              </div>
            </div>
            <div className='frame-row26'>
              {/* Add chat icon button here */}
              <button
                className='btn btn-icon btn-active-light-primary'
                onClick={() => setIsChatModalOpen(true)}
                style={{
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer',
                  padding: '5px',
                  marginLeft: '10px',
                }}
              >
                <FaComment size={20} color='#059BB6' />
              </button>
            </div>
          </div>
          <div className='frame-headerhelper'>
            <div className='frame-row29'>
              <span className='frame-text39'>Patient Name</span>
              <span className='frame-text40'>{claimDetails.claimDetails.claim.memberName}</span>
            </div>
            {/* <button
              className="frame-button19"
              onClick={() => handleViewNavigation('prev')}
              style={{
                visibility: (showPrevButton && currentView !== 'inpatient') ? 'visible' : 'hidden',
                cursor: 'pointer'
              }}
            >
              <FaChevronLeft />
            </button> */}
            <div className='frame-indicator1'>
              <span className='frame-text41'>
                {status === 'Request FGL' ||
                status === 'FGL RELEASED' ||
                status === 'Final Document Complete' ||
                status === 'FGL Review' ||
                status === 'Pending on FGL'
                  ? currentView === 'settlement'
                    ? 'SETTLEMENT'
                    : currentView === 'calendar'
                    ? 'Daily Monitoring'
                    : 'Admission'
                  : currentView === 'inpatient'
                  ? 'Admission'
                  : 'Daily Monitoring'}
              </span>
            </div>
            {/* <button
              className="frame-button19"
              onClick={() => handleViewNavigation('next')}
              style={{
                visibility: showNextButton ? 'visible' : 'hidden',
                cursor: 'pointer'
              }}
            >
              <FaChevronRight />
            </button> */}
            <div className='frame-row30'>
              <div className='frame-row31'>
                <div
                  className='frame-igl'
                  style={{display: 'flex', gap: '10px', alignItems: 'center'}}
                >
                  {(status === 'Pre-Registered' || status === 'Pending on IGL') && (
                    <button
                      type='submit'
                      className='frame-button11'
                      style={{
                        backgroundColor: '#059BB6',
                        color: 'white',
                        border: 'none',
                        borderRadius: '0.475rem',
                        padding: '0.75rem 1.5rem',
                        cursor: 'pointer',
                      }}
                      onClick={handleSave}
                    >
                      <span className='frame-text27 Body500Md'>Save As Draft</span>
                    </button>
                  )}

                  {/* {status === "Daily Monitoring" && (
                    <button
                      type="button"
                      className="frame-button11"
                      style={{
                        backgroundColor: '#059BB6',
                        color: 'white',
                        border: 'none',
                        borderRadius: '0.475rem',
                        padding: '0.75rem 1.5rem',
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        setCurrentView('calendar');
                        setView('calendar');
                        setActiveKey('calendar');
                        setTimeout(() => {
                          setCurrentView('calendar');
                        }, 0);
                      }}
                    >
                      <span className="frame-text27 Body500Md">Back</span>
                    </button>
                  )} */}

                  {status === 'IGL RELEASED' ? (
                    <button
                      className='frame-button20'
                      style={{
                        backgroundColor: '#059BB6',
                        color: 'white',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        border: 'none',
                        borderRadius: '0.475rem',
                        padding: '0.75rem 1.5rem',
                      }}
                      onClick={handleDownloadIGL}
                    >
                      <span className='frame-text42 Body500Md'>Download IGL</span>
                    </button>
                  ) : status === 'FGL RELEASED' ? (
                    <div style={{display: 'flex', gap: '10px'}}>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#059BB6',
                          color: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={handleDownloadIGL}
                      >
                        <span className='frame-text42 Body500Md'>Download IGL</span>
                      </button>
                      <button
                        className='frame-button20'
                        style={{
                          backgroundColor: '#059BB6',
                          color: 'white',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          border: 'none',
                          borderRadius: '0.475rem',
                          padding: '0.75rem 1.5rem',
                        }}
                        onClick={handleDownloadFGL}
                      >
                        <span className='frame-text42 Body500Md'>Download FGL</span>
                      </button>
                    </div>
                  ) : status === 'Registered' ||
                    status === 'Pre-Registered' ||
                    status === 'Pending on IGL' ? (
                    <button
                      className='frame-button20'
                      style={{
                        backgroundColor: shouldEnableButton ? '#059BB6' : '#E4E6EF',
                        color: 'white',
                        cursor: shouldEnableButton ? 'pointer' : 'not-allowed',
                        border: 'none',
                        borderRadius: '0.475rem',
                        padding: '0.75rem 1.5rem',
                        transition: 'background-color 0.3s ease',
                      }}
                      onClick={handleRequestIGL}
                      disabled={!shouldEnableButton}
                    >
                      <span className='frame-text42 Body500Md'>Request IGL</span>
                    </button>
                  ) : status === 'Daily Monitoring' ? (
                    <button
                      className='frame-button20'
                      style={{
                        backgroundColor: '#059BB6',
                        color: 'white',
                        cursor: 'pointer',
                        border: 'none',
                        borderRadius: '0.475rem',
                        padding: '0.75rem 1.5rem',
                      }}
                      onClick={handleRequestFGL}
                    >
                      <span className='frame-text42 Body500Md'>Request FGL</span>
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>

        {currentView === 'calendar' ? (
          <CalendarPage claimDetails={claimDetails} />
        ) : (
          <SettlementDetailPage
            claimDetails={claimDetails}
            onDocumentsStatusChange={handleDocumentsStatusChange}
            isEditingDiagnosis={isEditingDiagnosis}
            onEditClick={handleEditClick}
            onDocumentClick={handleDocumentClick}
            onValidateDiagnosis={validateDiagnosisFields}
            isFromDailyMonitoring={isFromDailyMonitoring}
            onDiagnosisDataChange={handleDiagnosisDataChange}
            currentView={currentView}
          />
        )}
      </div>

      {showFGLModal && (
        <CreateAppModal
          show={showFGLModal}
          handleClose={() => setShowFGLModal(false)}
          claimDetails={claimDetails}
          formattedDate={formattedDate}
          onSuccessSubmit={() => {
            sessionStorage.removeItem('recentlyUploadedLabels')
            setShowFGLModal(false)
            navigate('/claims')
          }}
        />
      )}
      <DocumentModal
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
        claimNumber={claimDetails.claimDetails.claim.claimNumber}
        token={user.currentUser?.token}
      />
      <ChatModal
        isOpen={isChatModalOpen}
        onClose={() => setIsChatModalOpen(false)}
        message=''
        claimDetails={claimDetails}
      />
    </>
  )
}

export default SettlementDetailPageWrapper
